<template>
  <div>
    <CouponPay
      v-if="visible"
      class="test-class"
      :visible="visible"
      :coupon-config="couponConfig"
      :pay-from="payFrom"
      @paySuccess="paySuccess"
      @closeModal="closeModal"
      @changeCoupon="changeCoupon"
      @changePay="changePay"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as Coupon from '@/api/coupon'
import client from '@/client/'
import CouponPay from '@/components/common/CouponPay'
import { PAGE_NUM } from '@/config/dataMap.js'
const ACT_FRM = 'act_202103_pc_pdf'
const PAY_FROM = PAGE_NUM.CompRedbag

export default {
  name: 'Redbag',
  components: {
    CouponPay,
  },

  data () {
    const { redbag } = this.$route.query
    const mainFrom = Number(redbag) || 0
    return {
      mainFrom,
      visible: false,
      payFrom: PAY_FROM,
      isFirst: true,
      couponConfig: {},
      monthSelected: 0,
    }
  },

  computed: {
    ...mapGetters([
      'loginStatus',
      'userInfo',
      'isContinuous',
      'isDiamondMember',
      'isSuperMember',
    ]),
    // 活动已过期
    isExpired () {
      if (!this.couponConfig.expires) {
        return true
      }
      return Date.now() > Number(this.couponConfig.expires) * 1000
    },
  },

  watch: {
    userInfo () {
      this.init()
    },
  },

  created () {
    this.init()
  },

  methods: {
    async init () {
      if (this.isFirst) {
        this.isFirst = false

        if (this.isSuperMember || this.isContinuous || this.isDiamondMember) {
          return
        }

        await this.getCouponConfig()
        if (this.isExpired) {
          return
        }

        if (this.mainFrom) {
          this.visible = true
          this.report({
            pay_click: 0,
            coupon_click: 0,
          })
        }
      }
    },

    async getCouponConfig () {
      const res = await Coupon.getCouponConfig({
        frm: ACT_FRM,
      })

      if (res.resp_common.ret === 0 && res.act_show && res.act_show[ACT_FRM]) {
        const act = res.act_show[ACT_FRM]
        this.couponConfig = act.config
      }
    },

    paySuccess () {
      this.$emit('paySuccess')
    },

    changePay (id) {
      this.report({
        pay_click: id,
        coupon_click: 0,
      })
    },

    changeCoupon (id) {
      this.report({
        pay_click: 0,
        coupon_click: id,
      })
    },

    closeModal () {
      this.visible = false
    },

    report ({ pay_click = 0, coupon_click = 0 }) {
      client.coupon.REPORT.reportRecallCoupon({
        main_from: this.mainFrom,
        pay_click,
        coupon_click,
        pagetype: 2,
      })
    },
  },
}
</script>
